import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'components';
import CommentTrigger from './components/CommentTrigger/CommentTrigger';
import CommentPopup from './components/CommentPopup/CommentPopup';
import styles from './Comment.scss';

const Comment = ({
  className,
  comments,
  commentIdToUpdate,
  questionId,
  onComment,
  onCancel,
  commentData,
  actions,
  mentionsAllowed,
  mentionableUsersArray
}) =>
  <Dropdown
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    renderTrigger={({open, isOpen}) =>
      <CommentTrigger
        className={className}
        open={open}
        questionId={questionId}
        isOpen={isOpen}
        numberOfComments={comments.length}
      />
    }
    renderContent={({close}) =>
      <CommentPopup
        comments={comments}
        onClose={close}
        onComment={onComment}
        onCancel={onCancel}
        commentData={commentData}
        actions={actions}
        commentIdToUpdate={commentIdToUpdate}
        mentionsAllowed={mentionsAllowed}
        mentionableUsersArray={mentionableUsersArray}
        questionId={questionId}
      />
    }
    popoverProps={{PaperProps: { className: styles.paperStyles }}}
  />;

Comment.propTypes = {
  className: PropTypes.string,
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      author: PropTypes.shape({
        email: PropTypes.string,
        name: PropTypes.string,
      }),
      createdAt: PropTypes.string,
      content: PropTypes.string,
      userAdmin: PropTypes.bool,
      allowedActions: PropTypes.arrayOf(PropTypes.string)
    }),
  ).isRequired,
  questionId: PropTypes.string,
  onComment: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  commentData: PropTypes.shape({
    placeholder: PropTypes.string.isRequired,
    cancelButtonText: PropTypes.string.isRequired,
    commentButtonText: PropTypes.string.isRequired,
    replyButtonText: PropTypes.string.isRequired,
    updateButtonText: PropTypes.string.isRequired,
    isAdminText: PropTypes.string,
    user: PropTypes.string,
  }).isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
    callback: PropTypes.func
  })),
  commentIdToUpdate: PropTypes.string,
  mentionsAllowed: PropTypes.bool,
  mentionableUsersArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    display: PropTypes.string
  }))
};

Comment.defaultProps = {
    actions: [],
    questionId: '',
    className: '',
    commentIdToUpdate: '',
    mentionsAllowed: false,
    mentionableUsersArray: []
};

export default Comment;
